import React from "react";
import { useTranslation } from "react-i18next";
import { Grid } from "@mui/material";
import { useTheme, lighten } from "@mui/material/styles";
import { EmployeePresenceAndLeavesSummaryDTO } from "../../../../models/employee-presence-and-leaves-summary/employee-presence-and-leaves-summary-dto";
import CircleAndIconContainer from "../../reusable-widget-link-components/CircleAndIconContainer/CircleAndIconContainer";
import { RoundedCalendarIcon } from "../../../../assets/icons";

const MyVacationBalanceLink = ({
  customSummary,
  loading,
}: {
  customSummary: EmployeePresenceAndLeavesSummaryDTO;
  loading: boolean;
}) => {
  const tRP = "components.custom_widget_links.my_presence_and_leaves.my_vacation_balance";
  const { t } = useTranslation();
  const theme = useTheme();
  return (
    <>
      <CircleAndIconContainer
        title={`${t(`${tRP}.title`)}`}
        mainInfo={customSummary?.vacationBalance?.toString() ?? "0"}
        description={`${t(`${tRP}.days`)}`}
        Icon={RoundedCalendarIcon}
        IconStyle={{
          width: "70%",
          height: "80%",
          color: lighten(theme.palette.primary.main, 0.4),
        }}
        titleStyle={{
          width: "min-content",
        }}
        loading={loading}
      />
    </>
  );
};
export default MyVacationBalanceLink;
